/*
 * @Description: In User Settings Edit
 * @Author: lic
 * @Date: 2019-07-22 16:14:31
 * @LastEditTime: 2019-09-25 18:20:21
 * @LastEditors: Please set LastEditors
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import clipboard from 'clipboard'
import clipper from '../static/clipper'
import 'babel-polyfill'
import store from './store'
import { setCookie, getCookie } from '@/utils/index.js'
import fly from './utils/flyio'
import weui from 'weui.js'
import wx from 'weixin-js-sdk'
import 'weui'
import 'lib-flexible/flexible'
import 'swiper/dist/css/swiper.css'
import vConsole from 'vconsole'
/* eslint-disable */
if(process.env.NODE_ENV !=='development'){
  if (process.env.MODE !== 'prod') {
    new vConsole()
  }
}
/* eslint-enable */
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(require('vue-wechat-title'))
Vue.use(clipper)

Vue.prototype.$weui = weui
Vue.prototype.$fly = fly
Vue.prototype.$store = store
Vue.prototype.$wx = wx
Vue.prototype.$clipboard = clipboard

router.beforeEach((to, from, next) => {
  if (to.path !== '/author') {
    console.log(to.path)
    setCookie('beforeLoginUrl', to.path) // 保存用户进入的url
  }
  next()
})

// 登录后跳转方法
Vue.prototype.goBeforeLoginUrl = () => {
  let url = getCookie('beforeLoginUrl')
  console.log(url)
  if (!url || url.indexOf('/author') !== -1) {
    router.push('/')
  } else {
    if (url === '/') {
      url = '/'
    }
    router.push(url)
    // setCookie('beforeLoginUrl', '')
  }
}

function getUserDeviceType () {
  var u = navigator.userAgent.toLowerCase()
  var isAndroid = u.indexOf('cimenandroidapp') > -1
  var isIOS = u.indexOf('cimeniosapp') > -1
  if (/micromessenger/.test(u)) {
    return 0
  } else if (isIOS) {
    return 1
  } else if (isAndroid) {
    return 2
  } else {
    return 0
  }
}
localStorage.setItem('USER_DEVICE_TYPE', getUserDeviceType())

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js